import axios from 'axios';

axios.defaults.withCredentials = true; // Assicurati che Axios invii i cookie con le richieste

const handleTokenExpiry = (error) => {
  if (error.response?.data?.message === 'Sessione scaduta, effettuare nuovamente il login.') {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login'; // Reindirizza alla pagina di login
  }
  throw error;
};

const login = async (credentials) => {
  console.log('Tentativo di login...');
  try {
    const response = await axios.post('/api/auth/login', credentials);
    const { accessToken, user } = response.data;

    // Salva l'access token nel localStorage
    console.log('Access Token ottenuto:', accessToken);
    localStorage.setItem('token', accessToken);

    // Imposta l'header Authorization per le future richieste
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

    return { accessToken, user };
  } catch (error) {
    console.error('Errore durante il login:', error.response ? error.response.data : error.message);
    throw error;
  }
};

const register = async (data) => {
  try {
    const response = await axios.post('/api/auth/register', data);
    return response.data; // { message }
  } catch (error) {
    console.error('Registration failed:', error);
    handleTokenExpiry(error);
    throw error;
  }
};

const getCurrentUser = async (token) => {
  try {
    const response = await axios.get('/api/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Failed to fetch current user:', error);
    // Se la sessione non è valida forziamo il logout immediato
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return;
    }
    handleTokenExpiry(error);
    throw error;
  }
};

const logout = async () => {
  try {
    await axios.post('/api/auth/logout');
  } catch (error) {
    console.error('Logout failed:', error);
    handleTokenExpiry(error);
  } finally {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  }
};


let isRefreshing = false;

axios.interceptors.response.use(
  response => response,
  async error => {
    console.log("auth token error:", error, error.config);
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isRefreshCall = url.includes('/api/auth/refresh-token');
    const isLogoutCall = url.includes('/api/auth/logout');

    // Se 401 su logout/refresh o refresh già in corso, forza logout e blocca loop
    if (status === 401 && (isRefreshCall || isLogoutCall || isRefreshing)) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    if (status === 401) {
      try {
        isRefreshing = true;
        const response = await axios.post('/api/auth/refresh-token');
        const newAccessToken = response.data.accessToken;

        console.log("Refreshing token:", newAccessToken);
        localStorage.setItem('token', newAccessToken);
        axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;

        // Riprova la richiesta originale con il nuovo token
        error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return axios(error.config);
      } catch (err) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

const ping = async (token, data = {}) => {
  try {
    const t = token || localStorage.getItem('token');
    if (t) {
      const response = await axios.post('/api/auth/me', data, {
        headers: {
          Authorization: `Bearer ${t}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    }
  } catch (error) {
    console.error('Failed to ping server:', error);
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return;
    }
    throw error;
  }
};

const requestPasswordReset = async (email) => {
  try {
    const response = await axios.post('/api/password/request-password-reset', { email });
    return response.data;
  } catch (error) {
    console.error('Failed to send password reset email:', error);
    throw error;
  }
};

const resetPassword = async (token, newPassword) => {
  try {
    console.log('Token:', token);
    console.log('New Password:', newPassword);
    const response = await axios.post('/api/password/reset-password', {
      token,
      password: newPassword,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to reset password:', error);
    throw error;
  }
};

const authService = {
  login,
  register,
  ping,
  getCurrentUser,
  logout,
  requestPasswordReset,
  resetPassword,
};

export default authService;
